<template>
	<div class="flex flex-col min-h-screen">
		<OrganismHeaderBar
			:menu-service-items="menuServiceItems"
			:menu-social-items="menuSocialItems"
			:menu-items="mainMenuItems()"
			:phone-number="baseCompanyData.phoneNumber"
			:phone-link="phoneLink"
			:home-link="homeLink"
			:is-sales-header="isSales"
			@click-menu-button="openMobileMenu"
			@click-appointment-button="openAppointmentDialog"
		/>

		<main class="template-base-slot grow flex flex-col">
			<slot />
		</main>
		<OrganismFooter
			:links="footerMenuItems()"
			:company-data="{
				...fitCompanyData,
				...baseCompanyData,
			}"
			:phone-link="phoneLink"
			@open-appointment-dialog="openAppointmentDialog"
		/>
		<AtomWhatsappButton class="fixed bottom-8 right-8" />
	</div>
	<OrganismDialogs />
	<OrganismNotifications />
</template>

<script lang="ts" setup>
import { homeLink, phoneLink } from '#fit/core/consts/links';
import menuServiceItems from '#fit/core/consts/menuServiceItems';
import menuSocialItems from '#fit/core/consts/menuSocialItems';
import * as fitCompanyData from '#fit/core/consts/companyData';
import * as baseCompanyData from '#base/core/consts/companyData';

defineProps<{
	pageTitle?: string;
	isSales?: boolean;
}>();

useExternalScripts();

const {
	openAppointmentDialog,
	openMobileMenu,
	isDialogOpen,
	isDialogBottom,
} = useDialogs();

useHead({
	bodyAttrs: {
		class: computed(() => {
			return isDialogOpen.value && !isDialogBottom.value ? 'overflow-hidden' : '';
		}),
	},
});
</script>
